import React from 'react'
import styled from 'styled-components'
import {
  Col,
  Row,
} from 'reactstrap'
import MultipleTypesChart from '../../organisms/ResearchCharts/multiple-types-chart'
import SunburstChart from '../../organisms/ResearchCharts/sunburst-chart'
import { LandTenureClient } from '../../../services/LandTenureClient/LandTenureClient';
import Loading from '../../atoms/Loading/Loading';
import debounce from 'lodash.debounce';
import ExportResultsButton from '../../atoms/ExportResultsButton/ExportResultsButton';
import { FaStopCircle } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl'
import { GRAPH_UNAGG_NALLOW_TERRITORIES } from '../../../logic/ResearchConfig';

const FormattedMessageNoResults = styled.div`
  font-size:23px;
`

export default class ResearchResult extends React.PureComponent {
    static defaultProps = {
        selectedTerritories: [],
        landTenureFilters: []
    }

    constructor() {
        super();

        this.state = {
          lastSeed: '',
          landTenureResults: []  
        };
    }


    renderGraphs(results, territories, products, kind, legendTextKey, legendUrl, exportData) {
        if (kind == "MULTIPLE") {
            return ( 
            <div>
                <MultipleTypesChart data = { results }
                territoriesLenght = { territories.length }
                productsLenght = { products.length }
                legendTextKey = { legendTextKey }
                legendUrl = { legendUrl }
                />

                <ExportResultsButton data = {exportData} />
            </div>
            );

        } else {
            return (
            <div>
                 <SunburstChart data = { results }
                    legendTextKey = { legendTextKey }
                    legendUrl = { legendUrl }
                />

                <ExportResultsButton data = {exportData} />
            </div>
            )
        }
    }

    renderLandTenure(data) {
        const legendTextKey = `survey.source.fundiario.${ this.props.selectedTerritoryType }`;

        
        if(this.needToBlockGraph()) {
            return (
                <div>
                    <Row className="p-4 justify-content-center">
                        <Col xs="4" className="text-center">
                            <FormattedMessageNoResults><FaStopCircle /> <FormattedMessage id="landtenure.graph.blocked" /></FormattedMessageNoResults>
                        </Col>                    
                    </Row>
                    <Row>
                        <ExportResultsButton data = {data.original} />
                    </Row>
                </div>
                
            );
        }

        if (this.props.selectedTerritories.length === 1) {
            return this.renderGraphs(data.results, this.props.selectedTerritories, data.results, "MULTIPLE", legendTextKey, "", data.original);

        } else {
            return this.renderGraphs(data.results, this.props.selectedTerritories, data.results, "SUNBURST", legendTextKey, "", data.original);
        }
    }

    async updateLtResults(seed) {                        
        const client = new LandTenureClient();
        const results = await client.getLandTenure(this.props.landTenureFilters, this.props.selectedPeriod,
            this.props.selectedTerritories, this.props.landTenureYear);
        this.setState({landTenureResults: results, lastSeed: seed});        
    }

    needToBlockGraph() {
        let selected =  this.props.selectedTerritories;
        let filterNotAllowed = selected.filter(x => 
                (x.kind == undefined ? false : GRAPH_UNAGG_NALLOW_TERRITORIES.includes(x.kind)
            ));
        return filterNotAllowed.length > 0;
    }

    render() {
        const {
            landTenureResults,
            lastSeed
        } = this.state;

        if (!this.props.selectedTerritories) {
            return null
        }

        if (this.props.selectedTerritories.length === 0) {
            return null
        }

        if (this.props.selectedTheme.name == 'FUNDIARIO') {
            if (!this.props.landTenureFilters.themes) {
                return null;
            }
            if (!this.props.landTenureFilters.themes.length === 0) {
                return null;
            }

            if(lastSeed !== this.props.seed) {
                const dUpdate = debounce(() => { this.updateLtResults(this.props.seed) }, 750);
                dUpdate();
                return (
                    <Row className="p-4">
                        <Col xs="4">
                            <Loading />
                        </Col>
                    </Row>
                );
            }

            if(landTenureResults.results.length > 0) {
                return this.renderLandTenure(landTenureResults);
            }
            else {
                return (
                    <Row className="p-4 justify-content-center">
                    <Col xs="4" className="text-center">
                        <FormattedMessageNoResults><FaStopCircle /> <FormattedMessage id="landtenure.no.results" /></FormattedMessageNoResults>
                    </Col>
                    </Row>
                );
            }
        }

        if (!this.props.selectedMeasurementUnit) {
            return null
        }
        if (!this.props.selectedProducts) {
            return null
        }
        if (this.props.selectedProducts.length === 0) {
            return null
        }

        return this.props.renderQuery((result) => {
            if (result === null || (typeof result === 'object' && result.length === 0)) {
                return null
            }

            const themeName = this.props.selectedTheme.name.split(' ').join('_');
            const legendTextKey = `survey.source.${ themeName }.${ this.props.selectedTerritoryType }`;
            const themeData = this.props.themes.find((item) => item.id === this.props.selectedTheme.id);
            const legendUrl = themeData.url;

            if (this.props.selectedTerritories.length === 1 ||
                this.props.selectedProducts.length === 1) {
                return this.renderGraphs(result, this.props.selectedTerritories, this.props.selectedProducts, "MULTIPLE", legendTextKey, legendUrl, result);
            } else {
                return this.renderGraphs(result, this.props.selectedTerritories, this.props.selectedProducts, "SUNBURST", legendTextKey, legendUrl, result);
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/molecules/ResearchResult/ResearchResult.js